// Navbar: menu mobilne (burger) i panel wyszukiwarki produktów
function toggleMenu(navbar, open) {
    const menu = navbar.querySelector('[data-mobile-menu]'),
        burger = navbar.querySelector('[data-menu-toggle]');

    if (!menu || !burger) {
        return;
    }

    menu.style.top = navbar.getBoundingClientRect().bottom + 'px';
    menu.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', open);
    document.body.classList.toggle('no-overflow', open);
}

function toggleSearch(navbar, open) {
    const panel = navbar.querySelector('[data-search-panel]'),
        toggle = navbar.querySelector('[data-search-toggle]');

    if (!panel || !toggle) {
        return;
    }

    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open);

    if (open) {
        const field = panel.querySelector('input[type="search"]');
        if (field) {
            field.focus();
        }
    }
}

function init() {
    const navbar = document.querySelector('[data-navbar]');

    if (!navbar) {
        return;
    }

    const menu = navbar.querySelector('[data-mobile-menu]'),
        burger = navbar.querySelector('[data-menu-toggle]'),
        searchToggle = navbar.querySelector('[data-search-toggle]'),
        searchPanel = navbar.querySelector('[data-search-panel]');

    if (burger && menu) {
        burger.addEventListener('click', () => {
            toggleSearch(navbar, false);
            toggleMenu(navbar, !menu.classList.contains('is-open'));
        });

        menu.addEventListener('click', (event) => {
            if (event.target.closest('a')) {
                toggleMenu(navbar, false);
            }
        });
    }

    if (searchToggle && searchPanel) {
        searchToggle.addEventListener('click', () => {
            toggleMenu(navbar, false);
            toggleSearch(navbar, searchPanel.hidden);
        });
    }

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            toggleMenu(navbar, false);
            toggleSearch(navbar, false);
        }
    });
}

export default {init};
